var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.963 4.46C15.654 3.538 16.23 2.27 16 1c-1.153.115-2.42.807-3.228 1.73-.691.923-1.268 2.076-1.037 3.345 1.268.115 2.536-.692 3.228-1.615ZM21 17.463c-.461 1.039-.807 1.615-1.383 2.538C18.695 21.27 17.542 23 15.927 23c-.69 0-1.037-.115-1.498-.346-.576-.23-1.037-.461-2.075-.461-.922 0-1.498.23-2.074.461-.462.115-.807.346-1.499.346-1.499 0-2.651-1.5-3.689-2.884-2.42-3.69-2.651-8.19-1.153-10.496 1.038-1.73 2.767-2.653 4.38-2.653.808 0 1.5.23 2.19.461h.001c.692.231 1.153.462 1.844.462.577 0 1.038-.115 1.614-.346.692-.23 1.384-.462 2.421-.462 1.499 0 2.997.693 4.035 2.077-3.574 1.845-2.997 6.92.576 8.304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.55ab248b82bba0f87b2947f2970532d0.svg";
export { ForwardRef as ReactComponent };